// removed by extract-text-webpack-plugin
module.exports = {"page":"print__page__fQs8f","subpage":"print__subpage__ky0BY","tableBordered":"print__tableBordered__qT-2X","noMargin":"print__noMargin__BbleJ","noBold":"print__noBold__1sVtw","hideLeftBorder":"print__hideLeftBorder__23aC9","tableRightBorder":"print__tableRightBorder__2ZD_E","limitCell":"print__limitCell__37AmX"};


//////////////////
// WEBPACK FOOTER
// ./src/css/print.css
// module id = 1384
// module chunks = 0